import React from "react";
import { STATUS_STYLE } from "../lib/constants";
import { Badge } from "./ui/badge";

export function StatusBadge({ status }) {
  const cls = STATUS_STYLE[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <Badge
      variant="outline"
      className={`${cls} font-medium border`}
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
    >
      {status}
    </Badge>
  );
}
